exports = module.exports = require("../../../../../../../../textelements/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", ""]);

// exports
